import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {mr} from "@pg-design/helpers-css";
import {CarOutlineIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../app/rp_reducer";
import {TravelTabsType} from "../types/TravelTabsType";

export const useTravelTimeTabs = () => {
    const travelTime = useSelector((state: IRPStore) => state.search.travelTime);
    const [currentTab, setCurrentTab] = useState(travelTime.isActive ? TravelTabsType.TRAVEL_TIME : TravelTabsType.LOCATION);

    useEffect(() => {
        setCurrentTab(travelTime.isActive ? TravelTabsType.TRAVEL_TIME : TravelTabsType.LOCATION);
    }, [travelTime.isActive]);

    return {
        activeTravelTimeTab: currentTab,
        travelTimeTabs
    };
};

const travelTimeTabs = [
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <MapMarkerOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Lokalizacja
                </Text>
            </>
        ),
        value: TravelTabsType.LOCATION
    },
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <CarOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Czas dojazdu
                </Text>
            </>
        ),
        value: TravelTabsType.TRAVEL_TIME
    }
];
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {mr} from "@pg-design/helpers-css";
import {CarOutlineIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../app/rp_reducer";
import {TravelTabsType} from "../types/TravelTabsType";

export const useTravelTimeTabs = () => {
    const travelTime = useSelector((state: IRPStore) => state.search.travelTime);
    const [currentTab, setCurrentTab] = useState(travelTime.isActive ? TravelTabsType.TRAVEL_TIME : TravelTabsType.LOCATION);

    useEffect(() => {
        setCurrentTab(travelTime.isActive ? TravelTabsType.TRAVEL_TIME : TravelTabsType.LOCATION);
    }, [travelTime.isActive]);

    return {
        activeTravelTimeTab: currentTab,
        travelTimeTabs
    };
};

const travelTimeTabs = [
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <MapMarkerOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Lokalizacja
                </Text>
            </>
        ),
        value: TravelTabsType.LOCATION
    },
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <CarOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Czas dojazdu
                </Text>
            </>
        ),
        value: TravelTabsType.TRAVEL_TIME
    }
];
